var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"filtersWrapper"},_vm._l((_vm.notEmptyFilters),function(filter,index){return _c('filterItem',{key:`filter-item-${index}`,class:{'last' : index === _vm.notEmptyFilters.length - 1},attrs:{"filter":filter}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }